import moment from "moment";
import React from "react";
import {
  Table,
  Badge,
  Dropdown,
  Button,
  Form,
  Row,
  Col,
  Container,
} from "react-bootstrap";
import { FaEye } from "react-icons/fa";
import { MdDeleteForever, MdEdit } from "react-icons/md";
import { Link } from "react-router-dom";
import LottiLoader from "../../../components/shared/Loader/LottiLoader";
import {
  changeStatusApi,
  deleteEventApi,
} from "../../../hooks/ApisContainer/Event";
import useToastContext from "../../../hooks/useToastContext";
import Swal from "sweetalert2";
import { textTruncateMore } from "../../../helper/helper";
const TableList = ({
  event,
  handleShowModal,
  pageLoader,
  fetchedGetEvents,
  currentPage,
  rowsPerPage
}) => {
  const notification = useToastContext();

  const handleChangeStatus = (data = {}) => {
    const requestPayload = { ...data };
    changeStatusApi(
      requestPayload,
      notification,
      (loading, error, response) => {
        if (!error) {
          fetchedGetEvents();
        }
      }
    );
  };

  const handleDeleteEvent = (data = {}) => {
    Swal.fire({
      text: "Are you sure you want to delete?",
      icon: "error",
      showCancelButton: true,
      confirmButtonColor: "#ff6004",
      confirmButtonText: "Delete",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const requestPayload = { ...data };
          deleteEventApi(
            requestPayload,
            notification,
            (loading, error, response) => {
              if (!error) {
                fetchedGetEvents({}, true);
              }
            }
          );
        } catch (error) {
          console.error("error:", error);
        }
      }
    });
  };

  return (
    <div className="card  overflow-hidden">
      <div className="">
        <div className="table-responsive">
          <Table responsive="md" className="mb-0">
            <thead>
              <tr>
                <th>S.N</th>
                <th>Name</th>
                <th>Description</th>
                <th>Address</th>
                <th>Created At</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {!pageLoader &&
                event &&
                event?.length > 0 &&
                event.map((item, i) => {
                  return (
                    <tr key={i}>
                      <td className="">
                        <strong className="text-black">{(currentPage - 1) * rowsPerPage + i + 1}</strong>
                      </td>
                      <td style={{ width: "18%" }}>{textTruncateMore(item.name, 35)}</td>
                      <td style={{ width: "25%" }}>

                        {textTruncateMore(item.description, 60)}
                      </td>
                      <td>{textTruncateMore(item.address, 60)}</td>
                      <td>{moment(item.createdAt).format("YYYY-MM-DD")}</td>
                      <td>
                        <Form.Check // prettier-ignore
                          defaultChecked={item.status === "active"}
                          type="switch"
                          id="custom-switch"
                          onChange={(e) =>
                            handleChangeStatus({
                              id: item._id,
                              type: "event",
                              status: e.target.checked ? "active" : "inactive",
                            })
                          }
                        />
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center">
                          <Button
                            className="bg-transparent border-0 text-black fs-5 px-1"
                            onClick={() => handleShowModal(item)}
                          >
                            <MdEdit />
                          </Button>
                          <Link className="text-danger fs-5 px-1">
                            <MdDeleteForever
                              onClick={() =>
                                handleDeleteEvent({ id: item._id })
                              }
                            />
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
          {pageLoader && (
            <Container className="d-flex justify-content-center align-items-center default-back">
              <span>
                <LottiLoader height={120} width={120} loader={true} />
              </span>
            </Container>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableList;
